export const OVERLAY_INSTANCES = Object.freeze({
    GALLERY: 'OVERLAY_GALLERY',
    HOME_OVERLAY: 'OVERLAY_HOME_OVERLAY',
    MENU_SIDEBAR: 'OVERLAY_MENU_SIDEBAR',
});
